module.exports = __webpack_public_path__ + "static/media/cancel_address_input.e0dacb4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/commonImages/cancel_address_input.svg
// module id = 736
// module chunks = 0